export enum CopyToClipboardStatus {
  COPIED,
  DEFAULT
}
